/**
* @author DefaultUser (Tools -> Custom Arguments...)
*/
/**
 * package: com.inq.stage
 * class: Resize
 * @extends com.inq.stage.DragResize 
 * @constructor
 */
com.inq.stage.Resize = function() {
	com.inq.stage.DragResize.call(this);
	this.className = "Resize";
	this.cursor = "se-resize";
};
$hxClasses['com.inq.stage.Resize'] = com.inq.stage.Resize;
/** @private @type {Array} */
com.inq.stage.Resize.__name__ = ["com","inq","stage","Resize"];
/** @private @type {Function} */
com.inq.stage.Resize.__super__ = com.inq.stage.DragResize;
for(var k in com.inq.stage.DragResize.prototype ) com.inq.stage.Resize.prototype[k] = com.inq.stage.DragResize.prototype[k];

/**
 * setResizable
 * Replaces the "FlashPeer.setResizable
 * Sets up the chat skin for being resized and replaces the version in the IJSF
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function setResizable():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.stage.Resize.setResizable = function () {
	if (com.inq.flash.client.control.FlashPeer.isPersistentWindow() || com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
		return;
	}
	var instance = new com.inq.stage.Resize();
	var pDoc = window.parent.document;
	var cntr = com.inq.ui.Container._getElementById("inqChatStage", pDoc);
	var dragHandleElem = com.inq.ui.Container._getElementById("inqDivResizeCorner", pDoc);

	/** ADA support - To make screen reader skip dragSafe inputs. **/
	for (var i = 0; i < dragHandleElem.length; i++) {
		dragHandleElem[i].setAttribute("aria-hidden", "true");
		dragHandleElem[i].setAttribute("alt", "");
		dragHandleElem[i].setAttribute("tabindex", "-1");
	}
	instance.init(dragHandleElem, cntr);
};


/**
 * whenDone is invoked following the mouse up event in uponDrop function
 * It is invoked via the setTimeout functiona and is NOT in the same thread as the
 * event handler.  This is by design so not to delay further event handling.
 *
 * $type TFun([],TEnum(Void,[]))
 * override public function whenDone ():Void
 * @override
 * @public
 * @this com.inq.stage.Resize
 * @return {void}
 */
com.inq.stage.Resize.prototype.whenDone = function() {
	this.titlebar.style.cssText = this.titlebarStyle;
	Application.ResizeStage(this.newWidth,this.newHeight);
};


/**
 * setDragBorder
 * Creates the border for resizing, a dashed line
 * Used by the mouse down handler "uponDragStart"
 *
 * $type TFun([],TEnum(Void,[]))
 * override private function setDragBorder():Void
 * @override
 * @private
 * @this com.inq.stage.Resize
 * @see uponDragStart
 * @author Fred A. Pinn <fpinn@TouchCommerce.com>
 * @return {void}
 */
com.inq.stage.Resize.prototype.setDragBorder = function() {
	this.stageLeft = this.root.style.left;
	this.stageTop = this.root.style.top;

	/** @type {number} */ 
	var height = Std.parseInt(this.root.style.height);
	/** @type {number} */ 
	var width = Std.parseInt(this.root.style.width);
	/** @type {number} */ 
	var borderWidth = 3;
	this.obj.style.cursor = "se-resize";
	
	/* Use the titlebar (drag area div) to show the resized borders. */
	this.titlebar = com.inq.ui.Container._getElementById("inqTitleBar",parent.document);
	if(null == this.titlebarStyle) this.titlebarStyle = this.titlebar.style.cssText;
	this.titlebar.style.top = this.root.style.top;
	this.titlebar.style.left = this.root.style.left;
	
	this.titlebar.style.borderStyle = "dashed";
	this.titlebar.style.cursor = "se-resize";
	this.titlebar.style.borderWidth = borderWidth + "px";
	this.titlebar.style.borderColor = com.inq.utils.Util.getConfig("dragBorderColor",com.inq.stage.DragResize.DEFAULT_BORDER_COLOR);
	this.titlebar.style.height = height - borderWidth + "px";
	this.titlebar.style.width = width - borderWidth + "px";
};


/**
 * setTop
 * Resize the drag border and move the drag image (Y-axis only)
 * drag image - this.obj
 * drag border - titlebar ;
 *
 * $type TFun([{ name => top, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * override private function setTop(top:Int)
 * @override
 * @private
 * @this com.inq.stage.Resize
 * @param {number}  top 
 * @return {void}
 */
com.inq.stage.Resize.prototype.setTop = function(top) {
	this.newHeight = top - this.pStart.Y + this.draggerHeight;
	this.titlebar.style.height = this.newHeight + "px";
	this.obj.style.top = top + "px";
};


/**
 * setLeft
 * Resize the drag border and move the drag image (X-axis only)
 * drag image - this.obj
 * drag border - titlebar ;
 *
 * $type TFun([{ name => left, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * override private function setLeft(left:Int)
 * @override
 * @private
 * @this com.inq.stage.Resize
 * @param {number}  left 
 * @return {void}
 */
com.inq.stage.Resize.prototype.setLeft = function(left) {
	this.newWidth = left - this.pStart.X + this.draggerWidth;
	this.titlebar.style.width = this.newWidth + "px";
	this.obj.style.left = left + "px";
};


/**
 * getDefaultMax - get the maximum {x, y} coordinates for the resizing
 * For the Resize it is the lower right corner of the visible screen minus the 
 * height and width of the drag image.
 *
 * $type TFun([],TDynamic(null))
 * override private function getDefaultMax():Dynamic
 * @override
 * @private
 * @this com.inq.stage.Resize
 * @return {Object} -  JSON
 */
com.inq.stage.Resize.prototype.getDefaultMax = function() {
	/** @type {number} */ 
	var width = Std.parseInt(this.obj.style.width);
	/** @type {number} */ 
	var height = Std.parseInt(this.obj.style.height);
	return { X : com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft() + com.inq.flash.client.chatskins.ScrollMonitor.getScrollWidth() - width, Y : com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop() + com.inq.flash.client.chatskins.ScrollMonitor.getScrollHeight() - height};
};


/**
 * getDefaultMin - get the minimum size {x, y} coordinates for the resizing
 * For the Resize it is the top left corner of the chat box plus the mimumum width and height
 *
 * $type TFun([],TDynamic(null))
 * override private function getDefaultMin():Dynamic
 * @override
 * @private
 * @this com.inq.stage.Resize
 * @return {null} -  JSON
 */
com.inq.stage.Resize.prototype.getDefaultMin = function() {
	return { X : this.pStart.X + Application.getMinWidth(), Y : this.pStart.Y + Application.getMinHeight()};
};


/**
 * uponDrop - onmouseup handler
 * restore the titlebar style and continue with the super.uponDrop
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * override private function uponDrop(e:Dynamic)
 * @override
 * @private
 * @this com.inq.stage.Resize
 * @param {null}  e - event information (non-IE), null (IE) 
 * @return {boolean}
 */
com.inq.stage.Resize.prototype.uponDrop = function(e) {
	this.titlebar.style.cssText = this.titlebarStyle;
	return com.inq.stage.DragResize.prototype.uponDrop.call(this,e);
};

/** @private @type {number} */
com.inq.stage.Resize.prototype.newHeight = null;
/** @private @type {number} */
com.inq.stage.Resize.prototype.newWidth = null;
/** @private @type {string} */
com.inq.stage.Resize.prototype.titlebarStyle = null;
/** @private @type {js.HtmlDom} */
com.inq.stage.Resize.prototype.titlebar = null;
/** @private @type {string} */
com.inq.stage.Resize.prototype.stageLeft = null;
/** @private @type {string} */
com.inq.stage.Resize.prototype.stageTop = null;
/** @type {com.inq.stage.Resize} */
com.inq.stage.Resize.prototype.__class__ = com.inq.stage.Resize;
com.inq.stage.Resize.__interfaces__ = [com.inq.stage.IDragResize];
